const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  FORGOT_PASSWORD_BEGIN: 'FORGOT_PASSWORD_BEGIN',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERR: 'FORGOT_PASSWORD_ERR',

  RESET_PASSWORD_BEGIN: 'RESET_PASSWORD_BEGIN',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERR: 'RESET_PASSWORD_ERR',

  TERMS_CONDITION_BEGIN: 'TERMS_CONDITION_BEGIN',
  TERMS_CONDITION_SUCCESS: 'TERMS_CONDITION_SUCCESS',
  TERMS_CONDITION_ERR: 'TERMS_CONDITION_ERR',

  SET_PASSWORD_BEGIN: 'SET_PASSWORD_BEGIN',
  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',
  SET_PASSWORD_ERR: 'SET_PASSWORD_ERR',

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN,
    };
  },

  loginSuccess: (data) => {
    return {
      type: actions.LOGIN_SUCCESS,
      data,
    };
  },

  loginErr: (err) => {
    return {
      type: actions.LOGIN_ERR,
      err,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: (data) => {
    return {
      type: actions.LOGOUT_SUCCESS,
      data,
    };
  },

  logoutErr: (err) => {
    return {
      type: actions.LOGOUT_ERR,
      err,
    };
  },

  forgotPasswordBegin: () => {
    return {
      type: actions.FORGOT_PASSWORD_BEGIN,
    };
  },

  forgotPasswordSuccess: (data) => {
    return {
      type: actions.FORGOT_PASSWORD_SUCCESS,
      data,
    };
  },

  forgotPasswordErr: (err) => {
    return {
      type: actions.FORGOT_PASSWORD_ERR,
      err,
    };
  },

  resetPasswordBegin: () => {
    return {
      type: actions.RESET_PASSWORD_BEGIN,
    };
  },

  resetPasswordSuccess: (data) => {
    return {
      type: actions.RESET_PASSWORD_SUCCESS,
      data,
    };
  },

  resetPasswordErr: (err) => {
    return {
      type: actions.RESET_PASSWORD_ERR,
      err,
    };
  },
  
  termsAndConditionBegin: () => {
    return {
      type: actions.TERMS_CONDITION_BEGIN,
    };
  },

  termsAndConditionSuccess: (data) => {
    return {
      type: actions.TERMS_CONDITION_SUCCESS,
      data,
    };
  },

  termsAndConditionErr: (err) => {
    return {
      type: actions.TERMS_CONDITION_ERR,
      err,
    };
  },

  setPasswordBegin: () => {
    return {
      type: actions.SET_PASSWORD_BEGIN,
    };
  },

  setPasswordSuccess: (data) => {
    return {
      type: actions.SET_PASSWORD_SUCCESS,
      data,
    };
  },

  setPasswordErr: (err) => {
    return {
      type: actions.SET_PASSWORD_ERR,
      err,
    };
  },
};

export default actions;
